export const DOC_FLOW_MAPPING_WIDGET_MAPPING_AREA_NOTIFICATION_ID =
  'mappingArea'

export const DOC_FLOW_MAPPING_WIDGET_MAPPING_AREA_FOUND_NOTIFICATION_ID =
  'mappingAreaFound'

export const DOC_FLOW_MAPPING_WIDGET_MAPPING_AREA_FOUND_ERROR_NOTIFICATION_ID =
  'mappingAreaFoundError'

export const DOC_FLOW_MAPPING_WIDGET_MAPPING_AREA_NOT_CHANGED_ERROR_NOTIFICATION_ID =
  'mappingAreaNotChangedError'

export const DOC_FLOW_MAPPING_WIDGET_MAPPING_AREA_TEST_IN_PROCESS_NOTIFICATION_ID =
  'mappingAreaTestInProcess'

export const DOC_FLOW_MAPPING_WIDGET_MAPPING_AREA_NOTIFICATION_ID_SERVER_ERROR =
  'mappingAreaServerError'

export const DOC_FLOW_MAPPING_WIDGET_MAPPING_IN_PROCESS_NOTIFICATION_ID =
  'mappingInProcess'

export const DOC_FLOW_MAPPING_WIDGET_MAPPING_CALLBACK_TIMEOUT = 3000
